import apiHandler from "../../core/apiHandler";

const inventoryTransferDetailApi = apiHandler(
    'inventory/transfers/details'
);

export default inventoryTransferDetailApi;
